import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-toggle-view.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';

/**
 * The IDB Toggle View component.
 * @element idb-toggle-view
 * @extends OutlineElement
 */
@customElement('idb-toggle-view')
export class IdbToggleView extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: Boolean, attribute: 'show-more' })
  showMore: Boolean = false;

  @property({ type: String, attribute: 'metric-value' })
  metricValue = '';

  @property({ type: String, attribute: 'metric-description' })
  metricDescription = '';

  @property({ type: String, attribute: 'chart-description' })
  chartDescription = '';

  @property({ type: String, attribute: 'chart-image' })
  chartImage = '';

  @property({ type: String, attribute: 'related' })
  related = '';

  @property({ type: String, attribute: 'source' })
  source = '';

  @property({ type: String, attribute: 'locale' })
  locale = 'en-US';

  @property({ type: String, attribute: 'chart-values' })
  chartValues = '';

  @property({ type: String, attribute: 'chart-categories' })
  chartCategories = '';

  @property({ type: String, attribute: 'chart-y-axis' })
  chartYAxis = '';
  

  @property({ type: Array, attribute: 'sdgs' })
  sdgs = [];

  @property({ type: Boolean, attribute: 'has-percent' })
  hasPercent = false;

  render(): TemplateResult {
    return html`
      <div class="chart-container ${
        this.showMore ? 'draw-graph' : 'draw-preview'
      }">
        ${this.showMore ? this.drawGraphTemplate() : this.drawPreviewTemplate()}
      </div>
    `;
  }

  drawGraphTemplate(): TemplateResult {
    return html`
      <section class="chart-heading">
        <div class="metric">
          <idb-heading margin-size="0px" level="h4" level-style="bold" level-size="4xl">${this.getMetricFormated()}</idb-heading>
          <idb-styled-text class="metric-description" margin-size="0px"><p><span class="text-sm">${
            this.metricDescription
          }</span></p></idb-styled-text>
        </div>
        <div class="description">
          <idb-styled-text margin-size="0px"><p><span class="text-xl font-semibold">${
            this.chartDescription
          }</span></p></idb-styled-text>
        </div>
      </section>
      <section class="chart-graph">
        <div class="related">
          <slot name="related"></slot>
          <div class="sdg-list">${this.sdgs.map(
            current => html`<img src="${current}"/>`
          )}</div>
          <slot name="source"></slot>
          <slot name="download"></slot>
        </div>
        <div class="graph">
          <idb-highcharts locale="${this.locale}"
            chart-values="${this.chartValues}"
            chart-categories="${this.chartCategories}"
            chart-y-axis="${this.chartYAxis}"
          >
          </idb-highcharts>
        </div>
      </section>
    `;
  }
  drawPreviewTemplate(): TemplateResult {
    return html`
      <section class="chart-heading">
        <idb-heading margin-size="0px" level="h4" level-style="bold" level-size="3xl">${this.getMetricFormated()}</idb-heading>
        <idb-styled-text class="metric-description" margin-size="0px"><p><span class="text-sm">${
          this.metricDescription
        }</span></p></idb-styled-text>
        <idb-styled-text margin-size="0px"><p><span class="text-sm font-semibold">${
          this.chartDescription
        }</span></p></idb-styled-text>
      </section>
      <section class="chart-image">
        <img src="${this.chartImage}">
      </section>
    `;
  }

  private getMetricFormated(): String {
    const numericValue = parseFloat(this.metricValue.replace(/[%$]/g, ''));
    const unit = this.metricValue.replace(numericValue.toString(), '');
    const formattedNumber = numericValue.toLocaleString(this.locale);
    return unit == "$" ? `${unit}${formattedNumber}`:`${formattedNumber}${unit}`;
  }
}
